import * as React from 'react'
import { render } from 'react-dom'

import StoreSingleton from './store/store'

import CustomerMethods from './api/CustomerMethods'
import {
  CUSTOMER_METHODS_PLACE_BETS,
  CUSTOMER_METHODS_SWITCH_EVENTS,
  BWG_METHODS_SWITCH_COMPETITOR,
  //BWG_METHODS_SET_ODDS_STATE,
  CUSTOMER_METHODS_SEEK_EVENTS,
  CUSTOMER_METHODS_SET_HEIGHT,
  CUSTOMER_METHODS_OPEN_COMPETITOR_STATS,
  CUSTOMER_METHODS_OPEN_EVENT_STATS,
  CUSTOMER_METHODS_GET_COMPETITOR_IMAGE,
  CUSTOMER_METHODS_SEND_CURRENT_PHASE_DATA,
  CUSTOMER_METHODS_CLOSE_EVENT,
  VIDEO_PLAYER_CREATE,
  VIDEO_PLAYER_DESTROY,
  INIT_APPLICATION_STARTED
} from './actions/actionTypes'

import { Provider } from 'react-redux'
import { IConfigState, IState } from './store/state';

// Conditional Polyfill. If babel-polyfill already exists and is importet it would throw an error

// @ts-ignore: _babelPolyfill present on global if previously imported/required
if (!(global as any)._babelPolyfill) {
    // tslint:disable-next-line
    require('babel-polyfill');
}
/*
 * INIT APPLICATION SETUP STUFF
 */

// Matomo tracking is injected into the global scope by VIP-Backend project (PHP)
// so we can only access it from the window object

let _customerMethods: any

const initApplication = (options:IConfigState, requiredOptions:any) => {
  const store = new StoreSingleton({ config: options } as any)
  const applicationOptions:any = store.getOptions()
  const componentName: string = applicationOptions.config.componentName === 'Root' ? 'App' : applicationOptions.config.componentName

  if(!store.isInit() && !checkForRequiredOptions(requiredOptions, Object.keys(applicationOptions.config))) {
    return console.error('The application can not be initialized')
  }

  _customerMethods.addStore(store.getStore())

  renderComponent(
    importComponent( componentName ),
    applicationOptions.config.componentContainer,
    store,
    options
  )
  store.getStore().dispatch( { type: INIT_APPLICATION_STARTED } )
}

const updateApplication = () => {
  const store = new StoreSingleton({} as any)
  const applicationOptions:IState = store.getOptions();
  
  renderComponent(
    importComponent( applicationOptions.config.componentName ),
    applicationOptions.config.componentContainer,
    store,
    true
  )
}

const checkForRequiredOptions = (requiredOptions:any, options:any) => {
  const missingOptions:Array<any> = arrayDiffToReference(requiredOptions, options)
  if (missingOptions.length) {
    return console.error(`The following option/s miss -> ${missingOptions}`)
  }
  return true
}

const arrayDiffToReference = (ref:Array<any>, arr:Array<any>) => ref.reduce( (result:any, e:any) => {
  arr.indexOf(e) >= 0 || result.push(e)
  return result
  }, [])

/*
 * INIT SINGLE COMPONENT STUFF
 */

const renderComponent = (Component:any, componentContainer:any, store:any, options: any) => {
  if(options) {
    // Render passed component/app to previously defined
    render(<Provider store={store.getStore()}><Component /></Provider>, componentContainer);
  }
}

const importComponent = (componentName:any) => {
  return require(`./containers/${componentName}`).default
}

const addComponent = (data: any) => {
  _customerMethods = new CustomerMethods()

  initApplication (
    data,
    [
      "componentName",
      "componentContainer",
      "layout",
      "clientId",
      "hostedSolutionAlias",
      "language",
      "baseUrl"
    ]
  )

    // this is a test to simulate a subscription call
    // setTimeout( () => handleScubscription({type: 'test', data: {test: 1234, hello: 'world'}}), 3000 )

  return {
    events: {
      CUSTOMER_METHODS_PLACE_BETS,
      //BWG_METHODS_SET_ODDS_STATE,
      BWG_METHODS_SWITCH_COMPETITOR,
      CUSTOMER_METHODS_SWITCH_EVENTS,
      CUSTOMER_METHODS_SEEK_EVENTS,
      CUSTOMER_METHODS_SET_HEIGHT,
      CUSTOMER_METHODS_OPEN_COMPETITOR_STATS,
      CUSTOMER_METHODS_OPEN_EVENT_STATS,
      CUSTOMER_METHODS_GET_COMPETITOR_IMAGE,
      CUSTOMER_METHODS_SEND_CURRENT_PHASE_DATA,
      CUSTOMER_METHODS_CLOSE_EVENT,
      VIDEO_PLAYER_CREATE,
      VIDEO_PLAYER_DESTROY
    },
    unsubscribe: (id: string) => _customerMethods.unregisterSubscriber(id),
    subscribe: ( subscriber: any ) => _customerMethods.registerSubscriber( subscriber ),
    dispatch: ( messageObject: any ) => _customerMethods.handleDispatch( messageObject ),
  }
}

const updateComponent = (data: any) => {
  const store = new StoreSingleton({} as any);

  store.setOptions(data)

  updateApplication();
}

export default {
  init: addComponent,
  update: updateComponent
}
